const accountConstants = {
    GET_ALL_ACCOUNTS: "GET_ALL_ACCOUNTS",
    ADD_ACCOUNT: "ADD_ACCOUNT",
    DELETE_ACCOUNT: "DELETE_ACCOUNT",
    UPDATE_ACCOUNT: "UPDATE_ACCOUNT",
}

export default accountConstants;